import { GzTopThreatsWebComponent } from './component/TopThreatsWebComponent';

export { GzTopThreatsWebComponent };
